export default "__VITE_ASSET__BR$moCnL__"